import { useCallback, useEffect, useState } from 'react'
import { getMapSet } from '../../services/map-set'
import { logger } from '../../utils/logger'

export interface MapSetFetchState {
  endpointIds: Set<string>
  setEndpointIds: React.Dispatch<React.SetStateAction<Set<string>>>
  loading: boolean
  error: string | null
  setError: (value: string | null) => void
  refetch: () => Promise<void>
}

export function useMapSetFetch(caseId: string | null): MapSetFetchState {
  const [endpointIds, setEndpointIds] = useState<Set<string>>(new Set())
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async () => {
    if (!caseId) {
      setEndpointIds(new Set())
      setError(null)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const data = await getMapSet(caseId)
      setEndpointIds(new Set(data.endpointIds))
    } catch (err) {
      logger.warn('useMapSet', 'Failed to fetch map set from backend', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch map set')
    } finally {
      setLoading(false)
    }
  }, [caseId])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { endpointIds, setEndpointIds, loading, error, setError, refetch }
}
